import { PageHeader } from "@/components/ui/PageHeader";
import { useFlag } from "@unleash/proxy-client-react";
import LocalAnalytics from "./LocalAnalytics";
import NumerousEmployeeAnalytics from "./NumerousEmployeeAnalytics";

function AnalyticsPage() {
  const isNumerousEmployee = useFlag("is-numerous-employee");

  return (
    <div className="flex flex-col max-h-screen w-full">
      <PageHeader
        header="Analytics"
        subHeader="Detailed information about the use of your organization's apps."
      />
      {!isNumerousEmployee ? <LocalAnalytics /> : <NumerousEmployeeAnalytics />}
    </div>
  );
}

export default AnalyticsPage;
